import type { ComparisonConfig } from './ComparisonPage';

const OPERA_FR: ComparisonConfig = {
  slug: 'hotelstack-vs-opera',
  competitorName: 'Oracle OPERA',
  heroTitle: 'HotelStack.io vs Oracle OPERA',
  heroSubtitle: 'Oracle OPERA est la r\u00e9f\u00e9rence historique du secteur \u2014 con\u00e7u il y a des d\u00e9cennies et portant encore la complexit\u00e9 et les tarifs de l\'\u00e8re entreprise. HotelStack.io offre une alternative moderne, cloud native, avec plus de modules, une tarification plus simple et z\u00e9ro surcharge d\'infrastructure.',
  overviewComparison: [
    { label: 'Architecture', hotelstack: 'SaaS cloud natif', competitor: 'Sur site h\u00e9rit\u00e9 / Cloud' },
    { label: 'Tarification', hotelstack: '\u00c0 partir de 49 $/mois', competitor: '500 $+/mois + licences' },
    { label: 'Impl\u00e9mentation', hotelstack: 'Gratuite \u2014 int\u00e9gration en 48h', competitor: 'Impl\u00e9mentation de 3 \u00e0 6 mois' },
    { label: 'Modules totaux', hotelstack: '36 int\u00e9gr\u00e9s', competitor: '20+ (licences s\u00e9par\u00e9es)' },
    { label: 'Restauration / POS', hotelstack: 'Int\u00e9gr\u00e9', competitor: 'Licence OPERA POS s\u00e9par\u00e9e' },
    { label: 'Segment cible', hotelstack: 'PME \u00e0 entreprise', competitor: 'Entreprise uniquement' },
  ],
  featureTable: [
    {
      category: 'PMS principal',
      features: [
        { name: 'Gestion des r\u00e9servations', hotelstack: true, competitor: true },
        { name: 'Tableau visuel des chambres', hotelstack: true, competitor: true },
        { name: 'Assistant d\'audit de nuit', hotelstack: true, competitor: true },
        { name: 'Gestion du folio client', hotelstack: true, competitor: true },
        { name: 'R\u00e9servations de groupe', hotelstack: true, competitor: true },
        { name: 'Portail d\'enregistrement en ligne', hotelstack: true, competitor: 'Module compl\u00e9mentaire' },
      ],
    },
    {
      category: 'Cloud et accessibilit\u00e9',
      features: [
        { name: 'V\u00e9ritable cloud natif', hotelstack: true, competitor: 'Hybride' },
        { name: 'Z\u00e9ro maintenance serveur', hotelstack: true, competitor: false },
        { name: 'Synchronisation multi-appareils en temps r\u00e9el', hotelstack: true, competitor: 'Limit\u00e9' },
        { name: 'Interface r\u00e9active moderne', hotelstack: true, competitor: false },
        { name: 'Mises \u00e0 jour automatiques', hotelstack: true, competitor: false },
        { name: 'Aucun personnel informatique requis', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Gestion des revenus',
      features: [
        { name: 'R\u00e8gles de tarification dynamique', hotelstack: true, competitor: true },
        { name: 'Simulateur de revenus hypoth\u00e9tique', hotelstack: true, competitor: false },
        { name: 'Surveillance des tarifs concurrents', hotelstack: true, competitor: 'Via Oracle BI' },
        { name: 'Pr\u00e9vision de la demande', hotelstack: true, competitor: true },
        { name: 'Analyses RevPAR', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'Restauration et op\u00e9rations',
      features: [
        { name: 'Terminal point de vente', hotelstack: true, competitor: 'Licence s\u00e9par\u00e9e' },
        { name: 'Module service en chambre', hotelstack: true, competitor: 'Licence s\u00e9par\u00e9e' },
        { name: 'Syst\u00e8me d\'affichage cuisine', hotelstack: true, competitor: false },
        { name: 'Planification du personnel', hotelstack: true, competitor: false },
        { name: 'Ordres de travail de maintenance', hotelstack: true, competitor: 'Via int\u00e9gration' },
      ],
    },
    {
      category: 'Co\u00fbt et int\u00e9gration',
      features: [
        { name: 'Int\u00e9gration gratuite', hotelstack: true, competitor: false },
        { name: 'Migration de donn\u00e9es gratuite', hotelstack: true, competitor: false },
        { name: 'Aucun co\u00fbt serveur', hotelstack: true, competitor: false },
        { name: 'Aucun frais de licence', hotelstack: true, competitor: false },
        { name: 'Tarification en devise r\u00e9gionale', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'R\u00e9silience et hors ligne',
      features: [
        { name: 'PWA fonctionnant hors ligne', hotelstack: true, competitor: false },
        { name: 'File d\'attente des modifications hors ligne', hotelstack: true, competitor: false },
        { name: 'Synchronisation en arri\u00e8re-plan \u00e0 la reconnexion', hotelstack: true, competitor: false },
        { name: 'R\u00e9conciliation tenant compte des conflits', hotelstack: true, competitor: false },
        { name: 'R\u00e9ception installable', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Ventes entreprises et groupes',
      features: [
        { name: 'Gestion des tarifs entreprises', hotelstack: true, competitor: 'Module compl\u00e9mentaire' },
        { name: 'R\u00e9servation de groupe avec listes de chambres', hotelstack: true, competitor: 'Module compl\u00e9mentaire' },
        { name: 'Rapports de cr\u00e9ances et de production', hotelstack: true, competitor: 'Module compl\u00e9mentaire' },
        { name: 'R\u00e9servations de restaurant', hotelstack: true, competitor: 'Module Micros' },
      ],
    },
    {
      category: 'Personnel et RH',
      features: [
        { name: 'Annuaire du personnel et planification', hotelstack: true, competitor: 'Via int\u00e9gration' },
        { name: 'Traitement de la paie', hotelstack: true, competitor: false },
        { name: 'Cong\u00e9s et pr\u00e9sences', hotelstack: true, competitor: false },
        { name: 'Analyses de performance', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$500+',
    hotelstackNote: 'Les 36 modules inclus. Aucun frais de licence. Aucun co\u00fbt serveur. Int\u00e9gration et migration gratuites. Tarification r\u00e9gionale en EUR, GBP, AED, INR, THB.',
    competitorNote: 'Licence entreprise \u00e0 partir de 500 $+/mois par \u00e9tablissement. Licences POS, S&C et OCRM s\u00e9par\u00e9es. Frais d\'impl\u00e9mentation \u00e0 partir de 50 000 $+. Serveurs sur site requis pour l\'\u00e9dition classique.',
  },
  advantages: [
    'Plus de 90 % de r\u00e9duction du co\u00fbt total de possession \u2014 aucun frais de licence, co\u00fbt serveur ou frais d\'impl\u00e9mentation',
    'Mise en service en 48 heures contre 3 \u00e0 6 mois d\'impl\u00e9mentation OPERA',
    'Interface cloud native moderne accessible depuis n\'importe quel appareil \u2014 aucun client de bureau n\u00e9cessaire',
    'Les 36 modules inclus dans un seul abonnement contre des licences de modules OPERA s\u00e9par\u00e9es',
    'Z\u00e9ro infrastructure informatique \u2014 pas de serveurs, pas de correctifs, pas de DBA Oracle requis',
    'Restauration et POS int\u00e9gr\u00e9s sans co\u00fbt suppl\u00e9mentaire contre licence OPERA POS s\u00e9par\u00e9e',
    'Tarification r\u00e9gionale en 6 devises pour que les h\u00f4tels paient en devise locale',
    'Migration de donn\u00e9es gratuite depuis OPERA avec \u00e9quipe de support d\u00e9di\u00e9e',
  ],
  verdict: {
    title: 'Notre verdict',
    summary: 'Oracle OPERA est la r\u00e9f\u00e9rence du secteur depuis des d\u00e9cennies et reste un choix solide pour les grandes cha\u00eenes d\'entreprise disposant d\'une infrastructure Oracle existante. Cependant, pour la grande majorit\u00e9 des h\u00f4tels, HotelStack.io offre plus de modules, une meilleure UX et des co\u00fbts consid\u00e9rablement r\u00e9duits sans les cycles d\'impl\u00e9mentation de plusieurs mois, la surcharge serveur et les licences complexes qu\'OPERA exige.',
    bestFor: [
      'H\u00f4tels souhaitant \u00e9liminer les co\u00fbts de licence et d\'infrastructure Oracle',
      '\u00c9tablissements fatigu\u00e9s des cycles lents d\'impl\u00e9mentation et de mise \u00e0 jour OPERA',
      'H\u00f4tels n\u00e9cessitant une interface cloud native moderne sans d\u00e9pendance au client de bureau',
      'PME et \u00e9tablissements de taille moyenne exclus des plans entreprise OPERA',
      '\u00c9tablissements souhaitant tous les modules inclus sans frais de licence s\u00e9par\u00e9s',
    ],
  },
  faqItems: [
    { question: 'Puis-je migrer d\'Oracle OPERA vers HotelStack.io ?', answer: 'Oui. Notre \u00e9quipe de migration est sp\u00e9cialis\u00e9e dans les transitions d\'OPERA vers HotelStack. Nous importons les profils clients, l\'historique des r\u00e9servations, les codes tarifaires, les configurations de chambres et les blocs de groupe. La migration est gratuite et g\u00e9n\u00e9ralement termin\u00e9e en 48 \u00e0 72 heures sans interruption.' },
    { question: 'HotelStack.io prend-il en charge les m\u00eames int\u00e9grations qu\'OPERA ?', answer: 'HotelStack.io se connecte \u00e0 plus de 100 OTA, GDS via Amadeus et Sabre, et aux principales passerelles de paiement. Notre place de march\u00e9 d\'int\u00e9grations couvre le m\u00eame \u00e9cosyst\u00e8me. Nous fournissons \u00e9galement une API ouverte pour les int\u00e9grations personnalis\u00e9es.' },
    { question: 'Comment HotelStack.io se compare-t-il \u00e0 OPERA Cloud ?', answer: 'OPERA Cloud est la modernisation par Oracle de leur produit h\u00e9rit\u00e9. HotelStack.io a \u00e9t\u00e9 con\u00e7u cloud natif d\u00e8s le premier jour avec une pile technologique moderne. Nous offrons plus de modules (36 contre la base OPERA Cloud), une tarification plus simple, une int\u00e9gration plus rapide et aucune d\u00e9pendance \u00e0 l\'infrastructure Oracle.' },
    { question: 'HotelStack.io convient-il aux grandes cha\u00eenes h\u00f4teli\u00e8res actuellement sur OPERA ?', answer: 'Oui. Nos plans Cha\u00eene et Entreprise prennent en charge la gestion multi-\u00e9tablissements avec analyses centralis\u00e9es, distribution tarifaire et standards de marque \u2014 les m\u00eames capacit\u00e9s qui maintiennent les grandes cha\u00eenes sur OPERA, \u00e0 une fraction du co\u00fbt.' },
  ],
};

const RMS_CLOUD_FR: ComparisonConfig = {
  slug: 'hotelstack-vs-rms-cloud',
  competitorName: 'RMS Cloud',
  heroTitle: 'HotelStack.io vs RMS Cloud',
  heroSubtitle: 'RMS Cloud dessert le march\u00e9 h\u00f4telier APAC avec de solides fondamentaux PMS. HotelStack.io va plus loin avec 36 modules, une tarification multidevise mondiale, la restauration/POS int\u00e9gr\u00e9s et une gestion avanc\u00e9e des revenus \u2014 le tout \u00e0 un prix inf\u00e9rieur.',
  overviewComparison: [
    { label: 'Modules totaux', hotelstack: '36 modules int\u00e9gr\u00e9s', competitor: '12+ modules' },
    { label: 'Tarification', hotelstack: '\u00c0 partir de 49 $/mois', competitor: '\u00c0 partir de 80 $+/mois' },
    { label: 'Port\u00e9e mondiale', hotelstack: 'Plus de 40 pays', competitor: 'Principalement APAC' },
    { label: 'Restauration / POS', hotelstack: 'Int\u00e9gr\u00e9', competitor: 'Non disponible' },
    { label: 'Gestion des revenus', hotelstack: 'Avanc\u00e9e (int\u00e9gr\u00e9e)', competitor: 'Basique' },
    { label: 'Moteur de r\u00e9servation', hotelstack: 'BookMyRoom.io (gratuit)', competitor: 'Widget basique' },
  ],
  featureTable: [
    {
      category: 'PMS principal',
      features: [
        { name: 'PMS cloud', hotelstack: true, competitor: true },
        { name: 'Tableau visuel des chambres', hotelstack: true, competitor: true },
        { name: 'Gestion des r\u00e9servations', hotelstack: true, competitor: true },
        { name: 'Assistant d\'audit de nuit', hotelstack: true, competitor: true },
        { name: 'R\u00e9servations de groupe', hotelstack: true, competitor: true },
        { name: 'Portail d\'enregistrement en ligne', hotelstack: true, competitor: 'Limit\u00e9' },
      ],
    },
    {
      category: 'Revenus et distribution',
      features: [
        { name: 'Gestionnaire de canaux (100+ OTA)', hotelstack: true, competitor: 'OTA limit\u00e9s' },
        { name: 'R\u00e8gles de tarification dynamique', hotelstack: true, competitor: false },
        { name: 'Surveillance des tarifs concurrents', hotelstack: true, competitor: false },
        { name: 'Simulateur de revenus hypoth\u00e9tique', hotelstack: true, competitor: false },
        { name: 'Pr\u00e9vision de la demande', hotelstack: true, competitor: 'Basique' },
        { name: 'Analyses RevPAR', hotelstack: true, competitor: 'Basique' },
      ],
    },
    {
      category: 'Gestion des clients',
      features: [
        { name: 'Profils clients 360 degr\u00e9s', hotelstack: true, competitor: 'Basique' },
        { name: 'Gestion du programme de fid\u00e9lit\u00e9', hotelstack: true, competitor: false },
        { name: 'Automatisation de la communication client', hotelstack: true, competitor: 'Limit\u00e9' },
        { name: 'Analyses des d\u00e9penses clients', hotelstack: true, competitor: false },
        { name: 'T\u00e9l\u00e9chargement et v\u00e9rification d\'identit\u00e9', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Restauration et op\u00e9rations',
      features: [
        { name: 'Terminal point de vente', hotelstack: true, competitor: false },
        { name: 'Module service en chambre', hotelstack: true, competitor: false },
        { name: 'Syst\u00e8me d\'affichage cuisine', hotelstack: true, competitor: false },
        { name: 'Gestion du m\u00e9nage', hotelstack: true, competitor: true },
        { name: 'Ordres de travail de maintenance', hotelstack: true, competitor: false },
        { name: 'Planification du personnel et paie', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Multi-\u00e9tablissements et conformit\u00e9',
      features: [
        { name: 'Tableau de bord de la cha\u00eene', hotelstack: true, competitor: true },
        { name: 'Analyses inter-\u00e9tablissements', hotelstack: true, competitor: 'Limit\u00e9' },
        { name: 'Facturation multidevise', hotelstack: true, competitor: 'Centr\u00e9 AUD' },
        { name: 'Conformit\u00e9 fiscale r\u00e9gionale', hotelstack: true, competitor: 'APAC uniquement' },
        { name: 'Protection des donn\u00e9es RGPD', hotelstack: true, competitor: 'Limit\u00e9' },
      ],
    },
    {
      category: 'R\u00e9silience et hors ligne',
      features: [
        { name: 'PWA fonctionnant hors ligne', hotelstack: true, competitor: false },
        { name: 'File d\'attente des modifications hors ligne', hotelstack: true, competitor: false },
        { name: 'Synchronisation en arri\u00e8re-plan \u00e0 la reconnexion', hotelstack: true, competitor: false },
        { name: 'R\u00e9conciliation tenant compte des conflits', hotelstack: true, competitor: false },
        { name: 'R\u00e9ception installable', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Ventes entreprises et groupes',
      features: [
        { name: 'Gestion des tarifs entreprises', hotelstack: true, competitor: false },
        { name: 'R\u00e9servation de groupe avec listes de chambres', hotelstack: true, competitor: 'Limit\u00e9' },
        { name: 'Rapports de cr\u00e9ances et de production', hotelstack: true, competitor: false },
        { name: 'R\u00e9servations de restaurant', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Personnel et RH',
      features: [
        { name: 'Annuaire du personnel et planification', hotelstack: true, competitor: false },
        { name: 'Traitement de la paie', hotelstack: true, competitor: false },
        { name: 'Cong\u00e9s et pr\u00e9sences', hotelstack: true, competitor: false },
        { name: 'Analyses de performance', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$80+',
    hotelstackNote: 'Les 36 modules inclus. Tarification r\u00e9gionale en EUR, GBP, AED, INR, THB. Int\u00e9gration et migration de donn\u00e9es gratuites.',
    competitorNote: 'Tarification en AUD \u00e0 partir de 80 $+/mois. Frais suppl\u00e9mentaires pour le gestionnaire de canaux et les fonctionnalit\u00e9s premium. Support principalement APAC.',
  },
  advantages: [
    'Pr\u00e8s du triple des modules (36 contre 12+) avec toutes les fonctionnalit\u00e9s incluses \u00e0 un prix inf\u00e9rieur',
    'Couverture mondiale dans plus de 40 pays contre la focalisation de RMS Cloud sur les march\u00e9s APAC',
    'Module complet de restauration avec terminal POS, service en chambre et gestion de cuisine',
    'Gestion avanc\u00e9e des revenus avec tarification dynamique, pr\u00e9vision et simulateurs',
    'Connectivit\u00e9 de canaux plus forte avec 100+ OTA et GDS via Amadeus et Sabre',
    'Gestion du personnel avec planification, paie, pr\u00e9sence et suivi des performances',
    'Facturation multidevise en 6 devises contre tarification principalement en AUD',
    'Int\u00e9gration et migration de donn\u00e9es gratuites avec support d\u00e9di\u00e9 24h/24 7j/7',
  ],
  verdict: {
    title: 'Notre verdict',
    summary: 'RMS Cloud est un PMS comp\u00e9tent pour les \u00e9tablissements APAC avec de solides fondamentaux pour la gestion h\u00e9berg\u00e9e. HotelStack.io offre une solution plus compl\u00e8te avec 36 modules, une port\u00e9e mondiale, une gestion avanc\u00e9e des revenus et des capacit\u00e9s compl\u00e8tes de restauration/POS \u2014 le tout \u00e0 un prix inf\u00e9rieur. Pour les \u00e9tablissements cherchant au-del\u00e0 du PMS de base vers une gestion h\u00f4teli\u00e8re compl\u00e8te, HotelStack.io est le choix le plus solide.',
    bestFor: [
      'H\u00f4tels souhaitant une plateforme compl\u00e8te tout-en-un au-del\u00e0 du PMS de base',
      '\u00c9tablissements n\u00e9cessitant restauration, POS et gestion de cuisine int\u00e9gr\u00e9s',
      'H\u00f4tels s\'\u00e9tendant hors de l\'APAC n\u00e9cessitant conformit\u00e9 et distribution mondiales',
      '\u00c9tablissements souhaitant une gestion avanc\u00e9e des revenus et une tarification dynamique',
      'Cha\u00eenes multi-\u00e9tablissements n\u00e9cessitant des analyses centralis\u00e9es \u00e0 travers les \u00e9tablissements mondiaux',
    ],
  },
  faqItems: [
    { question: 'Puis-je migrer de RMS Cloud vers HotelStack.io ?', answer: 'Oui. Notre \u00e9quipe de migration g\u00e8re le transfert complet des donn\u00e9es depuis RMS Cloud, y compris les profils clients, l\'historique des r\u00e9servations, les configurations tarifaires et les configurations de chambres. La migration est gratuite et g\u00e9n\u00e9ralement termin\u00e9e en 48 heures sans interruption.' },
    { question: 'HotelStack.io fonctionne-t-il bien pour les h\u00f4tels australiens et APAC ?', answer: 'Absolument. HotelStack.io prend en charge la facturation multidevise y compris l\'AUD, la conformit\u00e9 fiscale r\u00e9gionale pour les march\u00e9s APAC et les connexions aux OTA centr\u00e9s APAC. De nombreux \u00e9tablissements APAC ont quitt\u00e9 RMS Cloud pour les modules suppl\u00e9mentaires et la port\u00e9e mondiale.' },
    { question: 'Comment la tarification de HotelStack.io se compare-t-elle \u00e0 RMS Cloud ?', answer: 'HotelStack.io d\u00e9marre \u00e0 49 $/mois avec les 36 modules inclus et une tarification r\u00e9gionale en 6 devises. RMS Cloud d\u00e9marre \u00e0 environ 80 $+/mois AUD avec moins de modules et des frais suppl\u00e9mentaires pour la gestion des canaux et les fonctionnalit\u00e9s premium.' },
    { question: 'HotelStack.io prend-il en charge les parcs de vacances et campings comme RMS Cloud ?', answer: 'HotelStack.io est con\u00e7u pour tous les types d\'h\u00e9bergement, y compris les h\u00f4tels, complexes h\u00f4teliers, auberges, \u00e9tablissements boutique et appartements avec services. Bien que RMS Cloud dispose de fonctionnalit\u00e9s sp\u00e9cifiques pour les parcs de vacances, la flexibilit\u00e9 de configuration de HotelStack.io prend en charge divers mod\u00e8les d\'h\u00e9bergement.' },
  ],
};

export const COMPARISON_FR_P2: Record<string, ComparisonConfig> = {
  'hotelstack-vs-opera': OPERA_FR,
  'hotelstack-vs-rms-cloud': RMS_CLOUD_FR,
};
